import { render } from "./LanguageSettings.vue?vue&type=template&id=25c253d4&scoped=true&lang=pug"
import script from "./LanguageSettings.vue?vue&type=script&lang=js"
export * from "./LanguageSettings.vue?vue&type=script&lang=js"

import "./LanguageSettings.vue?vue&type=style&index=0&id=25c253d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c253d4"]])

export default __exports__